import styled from "styled-components";
import { NotificationText, SubHeadline } from "../typography";
import editIcon from "../../assets/images/icons/edit-icon.svg";
import plusIcon from "../../assets/images/icons/plus-white-icon.svg";
import { Button } from "./button";
import { COLORS } from "../../assets/utils/enums/colors";
import { useLocation, useNavigate } from "react-router-dom";
import { ThemeType, ThemeTypeEnum } from "../../assets/utils/validation/types";
import { HeadlineType } from "../../assets/utils/enums/headline";
import { headlineItems } from "../../assets/utils/data/panel-items";
import helpIcon from '../../assets/images/icons/help-icon.svg';
import toast from "react-hot-toast";
import CustomToast from "./custom-toast";
import { ToastTypeEnum } from "../../assets/utils/enums/toast";

interface HeadlineProps {
  headline: HeadlineType;
  btn_link?: string;
  btn_text?: string;
  theme: ThemeType;
  isEdit?: boolean;
}

export default function Headline({
  headline,
  btn_link,
  btn_text,
  theme = ThemeTypeEnum.DEFAULT,
  isEdit = false,
}: HeadlineProps) {
  const navigate = useNavigate();
  const pathname = useLocation();
  return (
    <HeadlineStyle $theme={theme}>
      <span className={`${!btn_link && !btn_text ? "py-2" : ""}`}>
        <img
          src={
            headlineItems[headline].icon[theme === ThemeTypeEnum.LIGHT ? 1 : 0]
          }
          alt={headline + "-icon"}
        />
        <SubHeadline>{headlineItems[headline].headline}</SubHeadline>
        {pathname.pathname.includes("settings") && <HelpIcon src={helpIcon} alt="help-icon" onClick={() => toast((t) => (
          <CustomToast
            t={t}
            type={ToastTypeEnum.INFO}
            text={"На даний момент, інструкція для користувача відстуня.\nУ разі питань звертайтесь на пошту irynamertsalova@gmail.com"}
          />
        ), {duration: 10000})} />}
      </span>
      <span>
        {btn_link && btn_text && (
          <Button
            bgcolor={COLORS.secondary1}
            txtcolor={COLORS.white}
            brcolor={"transparent"}
            width="auto"
            brradius="24px"
            type="small"
            onClick={() => navigate(btn_link)}
          >
            {btn_text?.includes("Додати") && (
              <img src={plusIcon} alt="add-icon" />
            )}
            <NotificationText>{btn_text}</NotificationText>
          </Button>
        )}
        <Button
          bgcolor={"transparent"}
          txtcolor={COLORS.secondary1}
          brcolor={COLORS.secondary1}
          width="auto"
          brradius="24px"
          type="small"
          style={{ borderWidth: "2px" }}
          onClick={() => navigate(-1)}
        >
          <NotificationText className="fw-bold">Назад</NotificationText>
        </Button>
        {isEdit && <img data-type="edit-icon" src={editIcon} alt="edit-icon" />}
      </span>
    </HeadlineStyle>
  );
}

const HelpIcon = styled.img`
transition: all 200ms cubic-bezier(0.25, 0.1, 0.25, 1);
cursor: pointer;
&:hover {
  transform: scale(0.90);
  
}
  &:active {
    transform: scale(0.90);
  }
`

const HeadlineStyle = styled.span<{ $theme: ThemeType }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${SubHeadline} {
    color: ${COLORS.secondary1};
    padding-top: 4px;
  }
  span {
    display: flex;
    align-items: center;
    gap: 12px;
    img {
      height: 30px;
      width: 30px;

      &[data-type="edit-icon"] {
        height: 30px;
        width: 30px;
      }
    }

    ${Button} {
      img {
        width: 24px !important;
        height: 24px !important;
      }
      gap: 8px;
      /* padding: 8px 24px; */
    }
  }
`;
